import { heroStats } from '@/mocks/home';

export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/40"></div>
      <div className="absolute top-0 right-0 w-full md:w-1/2 h-full opacity-20 md:opacity-30">
        <div className="absolute inset-0 bg-gradient-to-l from-primary-200/60 via-accent-100/30 to-transparent"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-24 md:py-20">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 bg-primary-100/80 text-primary-700 text-xs font-semibold rounded-full mb-5 tracking-wider uppercase">
              数字视频平台
            </span>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-foreground-950 leading-tight tracking-tight">
              豆花视频{' '}
              <span className="text-primary-500">高清免费影视聚合</span>
            </h1>
            <p className="mt-4 text-lg md:text-xl text-foreground-600 font-medium">
              海量片源 · 极速播放 · 永久免费
            </p>
            <p className="mt-5 text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0">
              豆花视频聚合91视频、97视频、51视频三大频道优质内容，涵盖电视剧全集、最新电影、动漫动画、纪录片与综艺娱乐等十二大品类。每日200+片源持续更新，全站1080P高清不缓冲，让每一位数字视频爱好者都能畅享纯粹的观影体验。当前暑期档专题热映中，《暗夜追光》第二季、《盛世长歌》等重磅剧集全网独播。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mt-7">
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-black text-primary-500">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-600 mt-1">
                    {stat.label}
                  </div>
                  <div className="text-[10px] md:text-xs text-foreground-400">
                    {stat.desc}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll('#ranking');
                }}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                查看热门榜单
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll('#cards');
                }}
                className="w-full sm:w-auto px-8 py-3.5 bg-background-50 text-foreground-800 font-semibold text-sm rounded-lg border border-background-300 hover:border-primary-300 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                浏览精选推荐
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20cinematic%20collage%20with%20floating%20film%20strips%20and%20movie%20posters%2C%20warm%20golden%20spotlight%20illumination%2C%20modern%20digital%20streaming%20interface%20elements%2C%20elegant%20composition%20with%20film%20reels%20and%20play%20buttons%2C%20rich%20amber%20and%20crimson%20gradient%20tones%2C%20dark%20theater%20atmosphere%20with%20dramatic%20lighting%2C%20sophisticated%20movie%20entertainment%20aesthetic%2C%20high%20contrast%20visual%20style&width=960&height=720&seq=douhua-hero-main&orientation=landscape"
                alt="豆花视频 - 高清免费影视聚合平台主视觉"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}